import styled from "@emotion/styled";
import { ActionButton } from "../ActionButton/ActionButton";
import Box from "../../primitives/Box/Box";
import { StyledImage } from "../Image/Image";

export const ProductImage = styled(StyledImage)<{ disabled?: boolean }>`
  height: 155px;
  align-self: stretch;
  aspect-ratio: 1/1;
  width: 100%;
  object-fit: cover;
  border-radius: 8px 8px 0px 0px;
  display: block;
  opacity: ${({ disabled }) => (disabled ? 0.4 : 1)};
`;
export const StyledActionButton = styled(ActionButton)`
  width: 100%;
  background-color: white;
`;

export const WishlistButton = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 2;
  cursor: pointer;
`;

export const OverlayMessage = styled(Box)`
  transform: translate(-50%, -50%);
  opacity: 0.5;
  padding: 4px;
  z-index: 3;
  pointer-events: none;
`;
